import {useParams, useLocation} from '@remix-run/react';
import {useTranslation} from 'react-i18next';
import {Breadcrumb} from '~/features/shared';
import {BlogPageType} from '../../services/GetBlogPageService';

export function SectionHeader({data}: {data: BlogPageType}) {
  const blog = data.page.blog;

  const params = useParams();
  const {state} = useLocation();

  const category = params.category as string;

  const isFromBlogs = state?.from === 'blogs';
  const isFromCategory = state?.from === 'category';

  const {t} = useTranslation();

  return (
    <section className="flex relative flex-col gap-4 py-10 px-5 bg-gray-100 md:px-10 lg:px-28 lg:pt-24 lg:rounded-t-3xl">
      <h1 className="text-xs tracking-widest uppercase text-blue-dark">
        {t(blog.category)}
      </h1>

      <h1 className="text-4xl font-bold uppercase">{blog.title}</h1>

      {blog.excerptHtml ? (
        <div
          className="font-medium text-gray-600"
          dangerouslySetInnerHTML={{
            __html: blog.excerptHtml,
          }}
        />
      ) : null}

      <p className="text-sm font-medium text-gray-500">{blog.publishedAt}</p>

      <hr className="w-full h-px bg-black" />

      <Breadcrumb
        items={[
          {
            title: t('inicio'),
            to: '/',
          },
          {
            title: t('blogs'),
            to: '/blogs',
            navigateBack: isFromBlogs,
          },
          {
            title: t(category),
            to: `/blogs/${category}`,
            navigateBack: isFromCategory,
          },
          {
            title: blog.title,
          },
        ]}
      />
    </section>
  );
}
